import { SurveyResponseModel } from './survey-response-model';

export interface SurveyBreakEventModel {
  surveyResponse: SurveyResponseModel;
  groupIndex: number;
}
